module.exports = __webpack_public_path__ + "static/media/update-sub-banner.ac0c409b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subscription/update-sub-banner.jpg
// module id = 2920
// module chunks = 0